<template>
  <div class="search-atom">
    <input ref="input" type="text" class="search-atom__input" :placeholder="placeholder" v-model="query" @input="search" @focus="handleFocus" @blur="handleBlur" />
    <button class="search-atom__btn" @click="focusInput"><i class="bi bi-search"></i></button>
  </div>
</template>

<script>
export default {
  props: {
    entities: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      query: '',
      focused: false,
    };
  },
  computed: {
    route() {
      return this.$route.name;
    },
    placeholder() {
      return this.focused ? 'Sök...' : '';
    },
  },
  methods: {
    search() {
      let data = [];
      if (this.query.length >= 3) {
        data = this.entities.filter((entity) => {
          let nameKey = this.route === 'projects' ? 'fastighetsbeteckning' : this.route === 'communes' ? 'kommun' : this.route === 'builders' ? 'byggherre' : 'byggnadsTypString';
          return entity[nameKey].toLowerCase().includes(this.query.toLowerCase()) || (entity.id && this.query.length > 10 && entity.id.toLowerCase().includes(this.query.toLowerCase()));
        });
      } else {
        data = [];
      }
      this.$emit('handleSearch', data, this.query);
      return data;
    },
    focusInput() {
      this.$refs.input.focus();
    },
    handleFocus() {
      this.focused = true;
    },
    handleBlur() {
      this.focused = false;
    },
  },
};
</script>

<style scoped>
.search-atom {
  margin: 5px;
  position: relative;
  display: flex;
  justify-content: flex-end;
}
.search-atom__input {
  height: 50px;
  width: 100%;
  max-width: 300px;
  border-style: none;
  padding: 10px;
  font-size: 16px;
  letter-spacing: 2px;
  outline: none;
  border-radius: 5px;
  background-color: transparent;
  padding-right: 40px;
  color: black;
}
i {
  color: black;
}
.search-atom__input::placeholder {
  color: black;
  font-size: 16px;
  letter-spacing: 1.2px;
  font-family: 'bred', sans-serif;
}
.search-atom__btn {
  width: 50px;
  height: 50px;
  border-style: none;
  font-size: 20px;
  font-weight: bold;
  outline: none;
  cursor: pointer;
  border-radius: 50%;
  position: absolute;
  right: 0px;
  color: #e9e9e9;
  background-color: transparent;
  pointer-events: painted;
}
.search-atom__btn:active {
  background-color: #00279c;
}
.search-atom__btn:focus ~ .search-atom__input {
  border-radius: 0px;
  background-color: transparent;
}

@media all and (max-width: 500px) {
  .search-atom__input {
    max-width: 100%;
  }
}
@media all and (min-width: 800px) {
  /*   .search-atom {
    margin-right: 30px;
  } */
}
</style>
